import * as React from 'react';
import {CloseIcon, Dialog, Flex, Text} from "@fluentui/react-northstar";
import languageObject from "../../translations";

interface IConfirmDialogProps {
    show: boolean,
    title: string,
    subtitle?: string,
    content: string,
    button?: {
        title: string,
        icon?: JSX.Element,
        className?: string,
    },
    onConfirm: () => void,
    onCancel: () => void,
    loading?: boolean,
}

/**
 * Confirmation dialog
 */
class ConfirmDialog extends React.Component<IConfirmDialogProps, {}> {
    /**
     * Constructor
     * @param props
     */
    constructor(props: IConfirmDialogProps) {
        super(props);
    }

    /**
     * Allow component to render
     * @param nextProps
     */
    shouldComponentUpdate(nextProps: Readonly<IConfirmDialogProps>): boolean {
        return this.props.show || nextProps.show;
    }

    /**
     * Render component
     */
    render() {
        return (
            <Dialog
                open={this.props.show}
                closeOnOutsideClick={false}
                onConfirm={this.props.onConfirm}
                confirmButton={{
                    content: this.props.button?.title ?? languageObject.translate("Confirm"),
                    disabled: this.props.loading,
                    loading: this.props.loading,
                    icon: this.props.button?.icon,
                    className: this.props.loading ? "" : this.props.button?.className
                }}
                header={
                    <Flex fill gap={"gap.smaller"} vAlign={"center"}>
                        <Text styles={{whiteSpace: "nowrap"}} content={this.props.title} weight={"bold"}
                              size={"large"}/>
                        <Flex fill className={"pos-relative"}>
                            <Flex fill className={"fill-absolute"}>
                                <Text
                                    truncated
                                    content={this.props.subtitle}
                                    styles={{color: "darkgray", maxWidth: "100%"}}
                                    weight={"light"}
                                    size={"large"}
                                />
                            </Flex>
                        </Flex>
                    </Flex>
                }
                headerAction={{
                    content: <CloseIcon/>,
                    onClick: this.props.onCancel,
                    title: languageObject.translate("Close"),
                    styles: {margin: "-5px 0 0 15px"}
                }}
                content={
                    <Flex fill vAlign={"center"}>
                        <Text content={this.props.content}/>
                    </Flex>
                }
            />
        );
    }
}

export default ConfirmDialog;